import Keecloak from "keecloak"

export const kee = new Keecloak({
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: "eepos",
    clientId: "references"
});

/**
 * @param {RequestInfo} input
 * @param {RequestInit} init
 */
export async function fetchAPI(input, init = {}) {
    const res = await fetch(process.env['VUE_APP_API_BASE_URL'] + '/' + input, {
        ...init,
        headers: {
            Authorization: `Bearer ${kee.token}`,
            ...init.headers,
        }
    })
    return res
}